<template>
  <div>
    <!-- 禁言表单 -->
    <el-form :model="muteForm" status-icon :rules="rules" ref="muteForm" label-width="100px">
      <el-form-item label="禁言类型" prop="type">
        <el-select v-model="muteForm.type" placeholder="请选择" @change="changeType">
          <el-option label="圈子禁言" :value="0"></el-option>
          <el-option label="全域禁言" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属圈子" prop="circleId" v-if="muteForm.type == 0">
        <el-select v-model="muteForm.circleId" placeholder="请选择">
          <el-option v-for="item in circleDataList" :key="item.circleId" :label="item.name"
            :value="item.circleId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="禁言时长" prop="time">
        <el-input type="text" v-model="muteForm.time" placeholder="请输入禁言时长"></el-input>
      </el-form-item>
      <el-form-item label="时间类型" prop="unit">
        <el-select v-model="muteForm.unit" placeholder="请选择">
          <el-option label="分钟" :value="0"></el-option>
          <el-option label="小时" :value="1"></el-option>
          <el-option label="天" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="总禁言次数" prop="unit">
        <el-tag type="danger">{{ muteCount }}</el-tag>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('muteForm')">提交</el-button>
        <el-button @click="resetForm('muteForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { GetcircleListApi, setGuideSaveOrUpdateApi } from '@/api/user'
export default {
  props: {
    muteCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      muteForm: { type: 1, time: '15', unit: 0, userId: '', circleId: '' },
      circleDataList: [],
      rules: {
        time: [
          { required: true, trigger: 'change', message: '请输入禁言时长' }
        ],
        unit: [
          { required: true, trigger: 'change', message: '请选择时间类型' }
        ]
      }
    };
  },
  methods: {
    changeType(type) {
      console.log('type', type);
      if (type == 0 && !this.circleDataList.length) {
        this.getCircleDataFn(20);
      }
    },
    getCircleDataFn(size) {
      GetcircleListApi({ pageNum: 1, pageSize: size }).then(res => {
        if (res.code == 200) {
          this.circleDataList = res.data.records
        } else {
          this.$message.error(res.message)
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.muteForm.time) {
            this.$message.error('请输入禁言时长')
            return false
          }
          if (this.muteForm.unit == 0 && this.muteForm.time < 5) {
            this.$message.error('禁言时长不能小于5分钟')
            return false
          }
          this.$emit('muteSubmit', this.muteForm);
          this.muteForm = { type: 1, time: '', unit: 0, userId: '', circleId: '' }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style></style>